import React, { useContext, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Timesheet from '../../../Components/pages/timesheet/Timesheet';
import classes from './TimesheetPage.module.scss';
import { getTimesheet } from '../../../actions/timesheet';
import { generalEnums } from '../../../utils/enums';
import { PageContext } from '../../../context/context';
import LoadingWithSpinner from '../../../Components/common/LoadingWithSpinner/LoadingWithSpinner';
import NoResults from '../../../Components/common/NoResults/NoResults';
import WarningImg from '../../../Assets/images/warning.svg';
import MainButton from '../../../Components/common/buttons/MainButton';
import { useWindowSize } from '../../../utils/hooks';
import { responsiveSizeTimesheet } from '../../../utils/constants';

export default function TimesheetPage() {
  const params = useParams();
  const dispatch = useDispatch();
  const timesheet = useSelector((state) => state.timesheet);
  const ctx = useContext(PageContext);
  const { t } = useTranslation();
  const size = useWindowSize();
  const navigate = useNavigate();

  useEffect(() => {
    ctx.setPageType(generalEnums.TIMESHEET);
  }, [params, generalEnums, ctx]);

  useEffect(() => {
    dispatch(getTimesheet(params?.id, localStorage.getItem('UserId')));
  }, []);

  if (timesheet?.isAccessDenied) {
    return (
      <div className={classes.wrapperContainer}>
        <NoResults
          isMobile={size.width < responsiveSizeTimesheet}
          icon={<img alt="warning" src={WarningImg} />}
          primaryTxt={t('common.errors.permission')}
          secondaryTxt={t('common.errors.permissionTimesheet')}
        >
          <MainButton rounded action={() => navigate('/dashboard')}>
            {t('common.actions.godashboard')}
          </MainButton>
        </NoResults>
      </div>
    );
  }
  return (
    <section className={classes.pageContainer}>
      {timesheet?.data?.Status ? <Timesheet /> : <LoadingWithSpinner />}
    </section>
  );
}
